import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'

const state = {
  playlist: {},
  playlists: [],
  playlist_item: {},
  playlist_items: []
}

const getters = {
  singlePlaylist: state => state.playlist,
  allPlaylists: state => state.playlists,
  singlePlaylistItem: state => state.playlist_item,
  allPlaylistItems: state => state.playlist_items
}

const actions = {
  getPlaylists ({ commit }) {
    api.instance.get('playlists')
      .then(function (response) {
        const playlists = response.data.playlists
        commit(types.RECEIVE_PLAYLISTS, playlists)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getPlaylist ({ commit }, playlistId) {
    api.instance.get('playlists/' + playlistId)
      .then(function (response) {
        const playlist = response.data.playlist
        commit(types.RECEIVE_PLAYLIST, playlist)
      })
  },
  addEditPlaylist ({ commit, rootGetters }, playlist) {
    playlist.site_id = rootGetters.scopedSiteId

    if (playlist.playlist_id === 0) {
      api.instance.post('playlists', playlist)
        .then(function (response) {
          if (response.data.success === 'true') {
            playlist = response.data.playlist[0]
            commit(types.ADD_PLAYLIST, playlist)

            router.push({ name: 'PlaylistsEdit', params: { playlist_id: playlist.playlist_id } })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      api.instance.put('playlists/' + playlist.playlist_id, playlist)
        .then(function (response) {
          if (response.data.success === 'true') {
            playlist = response.data.playlist[0]
            commit(types.EDIT_PLAYLIST, playlist)

            router.push({ name: 'Playlist' })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deletePlaylist ({ commit }, playlist) {
    api.instance.delete('playlists/' + playlist.playlist_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_PLAYLIST, playlist)
        } else {
          alert(response.data.message)
        }
      })
  },
  addPlaylistItem ({ commit }, playlistItem) {
    api.instance.post('playlist_items', playlistItem)
      .then(function (response) {
        if (response.data.success === 'true') {
          playlistItem = response.data.playlist_item[0]
          commit(types.ADD_PLAYLIST_ITEM, playlistItem)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  deletePlaylistItem ({ commit }, playlistItem) {
    api.instance.delete('playlist_items/' + playlistItem.playlist_item_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_PLAYLIST_ITEM, playlistItem)
        } else {
          alert(response.data.message)
        }
      })
  },
  reorderPlaylistItem ({ commit }, params) {
    api.instance.put('playlist_items/order/' + params.playlist_item_id, { direction: params.direction })
      .then(function (response) {
        if (response.data.success === 'true') {
          let playlistItems = response.data.playlist_items
          commit(types.RECEIVE_PLAYLIST_ITEMS, playlistItems)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

const mutations = {
  [types.RECEIVE_PLAYLISTS] (state, playlists) {
    state.playlists = playlists
  },
  [types.RECEIVE_PLAYLIST] (state, playlist) {
    state.playlist = playlist
  },
  [types.ADD_PLAYLIST] (state, playlist) {
    state.playlists.push(playlist)
  },
  [types.EDIT_PLAYLIST] (state, playlist) {
    let playlistToEdit = state.playlists.find(
      function (ele) {
        if (ele.playlist_id === playlist.playlist_id) {
          return true
        }
      }
    )
    let index = state.playlists.indexOf(playlistToEdit)
    state.playlists[index] = playlist
  },
  [types.DELETE_PLAYLIST] (state, playlist) {
    let playlistToDelete = state.playlists.find(
      function (ele) {
        if (ele.playlist_id === playlist.playlist_id) {
          return true
        }
      }
    )
    let index = state.playlists.indexOf(playlistToDelete)
    state.playlists.splice(index, 1)
  },
  [types.RECEIVE_PLAYLIST_ITEMS] (state, playlistItems) {
    state.playlist.playlist_items = playlistItems
  },
  [types.ADD_PLAYLIST_ITEM] (state, playlistItem) {
    state.playlist.playlist_items.push(playlistItem)
  },
  [types.DELETE_PLAYLIST_ITEM] (state, playlistItem) {
    let playlistItemToDelete = state.playlist.playlist_items.find(
      function (ele) {
        if (ele.playlist_item_id === playlistItem.playlist_item_id) {
          return true
        }
      }
    )
    let index = state.playlist.playlist_items.indexOf(playlistItemToDelete)
    state.playlist.playlist_items.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
